"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePurchaseOrder = void 0;

var _getPurchaseOrderId = _interopRequireDefault(require("self-service-api/api/getPurchaseOrderId"));

var generatePurchaseOrder = function generatePurchaseOrder(termId, currencyCode, itemConfigurations, productBasedOffers) {
  var purchaseConfig = {
    termId: termId,
    currencyCode: currencyCode,
    itemConfigurations: itemConfigurations,
    productBasedOffers: productBasedOffers
  };
  return (0, _getPurchaseOrderId.default)(purchaseConfig);
};

exports.generatePurchaseOrder = generatePurchaseOrder;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/checkout/generatePurchaseOrder.js
// module id = 717
// module chunks = 5 6